import Route from "@mapmycustomers/shared/types/entity/Route";
import { EntityTypesSupportingRoutes } from "@mapmycustomers/shared/types/entity/types";
import { EntityTypesSupportedByMapsPage } from "@mapmycustomers/shared/types/map/types";

import getRouteStopsTypes from "./getRouteStopsTypes";

const getOnRouteVisibleTypes = (
  route: Route,
  visibleEntities: EntityTypesSupportedByMapsPage[]
): EntityTypesSupportingRoutes[] => {
  const routeStopsTypes = getRouteStopsTypes(route);
  return visibleEntities.filter((entityType): entityType is EntityTypesSupportingRoutes =>
    routeStopsTypes.includes(entityType as EntityTypesSupportingRoutes)
  );
};

export default getOnRouteVisibleTypes;
